import React, { useState } from "react";
import { useGetPlatformHealthQuery } from "../../../redux/services/admin/adminApi";
import { HealthBoard } from "./HealthBoard";
import { mapLiveHealth } from "./mapLiveHealth";

/**
 * Super-admin page for application health and release progression.
 * Service cards follow the selected stage. Release progression shows the API train.
 * @returns {JSX.Element}
 */
export default function AppHealthPage() {
  const [environmentId, setEnvironmentId] = useState("production");
  const { data, isLoading, isFetching, isError, refetch } =
    useGetPlatformHealthQuery(undefined, {
      pollingInterval: 60000,
    });
  const health = data?.data;
  const snapshot = health ? mapLiveHealth(health, environmentId) : null;

  return (
    <div className="min-h-full bg-[#eef1f4] p-4 md:p-6">
      {isLoading && !snapshot ? (
        <p className="text-sm text-[#687180]">
          Checking beta, alpha, and production…
        </p>
      ) : null}
      {isError && !snapshot ? (
        <div className="rounded-xl border border-[#f0dcb4] bg-white p-6">
          <p className="text-sm font-semibold text-[#202632]">
            Live health checks did not load.
          </p>
          <button
            type="button"
            onClick={() => refetch()}
            className="mt-3 text-sm font-medium text-[#4d5bd1]"
          >
            Try again
          </button>
        </div>
      ) : null}
      {snapshot ? (
        <div className="flex flex-col gap-3">
          {isFetching ? (
            <p className="text-xs text-[#687180]">Refreshing health checks…</p>
          ) : null}
          <HealthBoard
            snapshot={snapshot}
            onEnvironmentChange={setEnvironmentId}
          />
        </div>
      ) : null}
    </div>
  );
}

export { HealthBoard } from "./HealthBoard";
export { healthSnapshot } from "./snapshot";
export { mapLiveHealth } from "./mapLiveHealth";
